module.exports = __webpack_public_path__ + "assets/img/sidemenu-item05_active.34df5a34.svg";